var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { takeWhile } from 'rxjs/operators';
var NewContactModalComponent = /** @class */ (function (_super) {
    __extends(NewContactModalComponent, _super);
    function NewContactModalComponent(modalService, store, fb) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.store = store;
        _this.fb = fb;
        _this.isAlive = true;
        _this.contactForm = _this.fb.group({
            name: ['', Validators.required],
            email: ['', Validators.required],
            phone_prefix: ['', Validators.required],
            phone_number: ['', Validators.required]
        });
        _this.countryCode$ = _this.store.select(fromStore.getCountryCodes);
        _this.dialCodes = [];
        _this.countryCode$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (values) {
            // Initialize countryCodes variable
            if (values) {
                _this.countryCodes = values;
                for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                    var item = values_1[_i];
                    _this.dialCodes.push({
                        label: item.name + ' ' + item.dial_code,
                        value: item.code
                    });
                }
            }
        });
        return _this;
    }
    NewContactModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    NewContactModalComponent.prototype.ngOnInit = function () {
    };
    NewContactModalComponent.prototype.TAP_hasErrors = function (field) {
    };
    NewContactModalComponent.prototype.TAP_formErrors = function (field) {
    };
    NewContactModalComponent.prototype.TAP_formInvalid = function (field) {
        return false;
    };
    NewContactModalComponent.prototype.TAP_handleCancel = function () {
        this.closeModal();
    };
    NewContactModalComponent.prototype.TAP_handleConfirm = function () {
        this.closeModal();
    };
    return NewContactModalComponent;
}(AbstractModalContentComponent));
export { NewContactModalComponent };
